import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import DeungiHeader from "@src/components/deungi/DeungiHeader";

import { useSearchParams } from "react-router-dom";
import CorpDeungiTab from "@src/components/corpDeungi/CorpDeungiTab";
import CorpDeungiTicketBoard from "@src/components/corpDeungi/CorpDeungiTicketBoard";
import CorpDeungiContents from "@src/components/corpDeungi/CorpDeungiContents";
import CorpDeungiWatch from "@src/components/corpDeungi/CorpDeungiWatch";

const CorpDeungiMain = () => {
    const [searchParams] = useSearchParams();
    const [watchInfo, setWatchInfo] = useState("");
    const [handleSelect, setHandleSelect] = useState(searchParams.get("type") || "search");
    useEffect(() => {
        setHandleSelect(searchParams.get("type") || "search");
        setWatchInfo(searchParams.get("watch") || "");
    }, [searchParams]);

    return (
        <Container>
            <CorpDeungiWatch watchInfo={watchInfo} />
            <DeungiHeader title="미스고 법인 등기열람" />
            <CorpDeungiTab handleSelect={handleSelect} />
            <CorpDeungiTicketBoard />
            <CorpDeungiContents handleSelect={handleSelect} />
        </Container>
    );
};

const Container = styled.div`
    position: relative;
    height: 100vh;
    background-color: white;
    height: calc(var(--vh, 1dvh) * 100);
    animation: fadeIn 0.5s forwards;

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

const Wrapper = styled.div``;

export default CorpDeungiMain;
